// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jl-0";
export var fileCarousel = "_jl-2";
export var removeFileButton = "_jl-1";